<template>
  <div class="profile-picture" :style="{ 'backgroundImage': 'url(' + portraitUrl + ')' }" @click="$router.push({name: 'userAccountPersonnalInformation'})">
      <span class="hello" v-if="(this.user && 'firstname' in this.user && this.user.firstname != '')">{{ $t('global.hello', { name: this.username }) }}</span>
  </div>
</template>

<script>
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'

export default {
  name: 'SidenavProfilePicture',
  mixins: [userMixin, remoteConfigMixin],
  computed: {
    portraitUrl() {
      return require('@/assets/portrait.png')
    },
    username() {
      return (this.user && 'firstname' in this.user && this.user.firstname != '') ? this.user.firstname.replace(/^\w/, c => c.toUpperCase()) : ''
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.profile-picture {
  height: 90px;
  width: 90px;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 12px solid white;

  background-size: cover;

  transition: all 0.1s ease;

  &:hover {
    height: 98px;
    width: 98px;
    border-width: 8px;
    border-color: $white-darker;
    cursor: pointer;

    .hello{
      display: block;
    }
  }
}
.profile-picture-img {
  position: relative;
  border-radius: 50%;
  transition: all 0.5s ease;
  overflow: hidden;

  &:hover{
    transform: scale(1.05);
  }
}

.hello {
  display: none;
  font-family: Helvetica, sans-serif;
  font-weight: bold;
  position: absolute;
  z-index: 20;
  right: 0;
  transform: translateX(40px);
  background-color: white;
  padding: 10px 15px;
  border: 4px solid $primary-alt;
  border-radius: 15px;
}



</style>